import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Groups } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import React from 'react';
import Iconify from '../../../../components/iconify';
import { isAdmin } from '../../../../utils/share';
import { PROJECT_EDITOR_ROLE } from '../../../../Constants/ProjectConstants';

const settingsIcon = <Iconify icon="eva:settings-fill" />;

const Actions = ({ userRoleName, id, projectName, status, onAddMemberClick }) => {
  const navigate = useNavigate();
  const showAddMemberBtn = isAdmin() || PROJECT_EDITOR_ROLE.includes(userRoleName);

  const handleSettingsClick = (e) => {
    e.stopPropagation();
    navigate(`/project/${id}/settings`, { state: { name: projectName } });
  };
  return (
    <Grid container spacing={1} display="flex" justifyContent="space-between">
      <Grid item display="inline-flex">
        <Groups style={{ marginRight: '5px', marginTop: '2px' }} />
        <Typography variant="h5" gutterBottom>
          Members
        </Typography>
      </Grid>
      <Grid item paddingBottom="10px">
        {showAddMemberBtn && (
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={onAddMemberClick}
            // className={style.buttonRightMargin}
            sx={{ marginRight: '10px' }}
            disabled={status !== 'active'}
          >
            Add Member
          </Button>
        )}
        <Button variant="contained" startIcon={settingsIcon} onClick={handleSettingsClick}>
          Settings
        </Button>
      </Grid>
    </Grid>
  );
};

Actions.propTypes = {
  userRoleName: PropTypes.string,
  status: PropTypes.string,
  id: PropTypes.string,
  projectName: PropTypes.string,
  onAddMemberClick: PropTypes.func,
};

export default Actions;
